import { FormControl, FormHelperText, Typography, Box } from '@mui/material'
import { MaskedTextBox } from '@progress/kendo-react-inputs'
import React, { useMemo } from 'react'

const sx = {
  masedInput: {
    ".k-maskedtextbox": {
      height: 50,
      borderRadius: "5px",
      position: 'relative',
      backgroundColor: '#fff',
      fontSize: 14,
      fontWeight: '300',
      width: '100%',
      color: '#132F6A',
      borderStyle: 'solid',
      boxShadow: 'none',
      outline: 'none !important',
      padding: '0',
      border: '1px solid silver',
      '&:focus-within': {
        borderColor: '#0a78cd !important',
        backgroundColor: '#fff',
        caretColor: '#0A78CD',
        borderWidth: '1px !important',
        boxShadow: 'none !important',
        outline: 'none !important',
      },

      borderColor: '',
    }
  },
  masedInputError: {
    ".k-maskedtextbox": {
      backgroundColor: '#fff6f5 !important',
      border: '1px solid red',
      '&:focus-within': {
        borderColor: '#D14343 !important',
        backgroundColor: 'rgba(254, 67, 52, 0.05)',
      },
      borderColor: '#D14343 !important',
    },
  },
  masedInputIcon: {
    ".k-maskedtextbox": {
      padding: '0 35px !important',
    }
  },

  masedInputDisabled: {
    ".k-maskedtextbox": {
      '&:focus-within': {
        backgroundColor: '#E9E9EF',
      },
    }
  },

  masedInputWhite: {
    ".k-maskedtextbox": {
      '&:focus-within': {
        backgroundColor: '#f2f8fc',
        caretColor: '#25245f',
      },
    }
  },

  helperTextRoot: {
    fontSize: 10,
    color: '#25245F',
    letterSpacing: '-0.33px',
    marginTop: 1,
  },
  fieldIcon: {
    position: 'absolute',
    top: '38px',
    zIndex: 1,
    marginLeft: '10px',
  }
}

const MaskField = props => {
  const {
    placeholder,
    helperText,
    error,
    label,
    value,
    fullWidth,
    name,
    type,
    disabled,
    autoComplete,
    InputProps,
    ref,
    autoFocus,
    onChange,
    onBlur,
    onFocus,
    required,
    isMasked,
    bgwhite,
    isFormatHint = true,
    maskPatten,
    icon = false,
  } = props

  const id = useMemo(() => Math.random().toString(32).substr(3), [])
  const style = { opacity: disabled ? 0.5 : 1, width: fullWidth ? '100%' : '' }
  const handleKeyPress = e => {
    if (isMasked) return
    const validCharsRegex = /[\d()-+. -]/
    if (!e.key.match(validCharsRegex)) {
      e.preventDefault()
    }
  }

  const classes = [sx.masedInput];
  if (props.error) {
    classes.push(sx.masedInputError)
  }
  if (props.icon) {
    classes.push(sx.masedInputIcon)
  }
  if (props.disabled) {
    classes.push(sx.masedInputDisabled)
  }
  if (props.bgwhite) {
    classes.push(sx.masedInputWhite)
  }

  return (
    <FormControl sx={classes} style={style}>
      <Typography shrink disabled={disabled} style={isMasked ? { marginBottom: 5 } : {}}
        component={'label'}

        color={'primary'}
        htmlFor={id}
        sx={{
          marginBottom: '4px',
          fontSize: '14px',
          lineHeight: '21px',
          fontWeight: 500,
        }}
      >
        {label}
        {required ? <span className="text-danger">&nbsp;*</span> : null}
      </Typography>
      {icon ? <Box component={"img"} sx={sx.fieldIcon} src={icon} alt="icon" /> : null}
      <MaskedTextBox
        icon={icon}
        mask={maskPatten || ''}
        onChange={onChange}
        defaultValue={value}
        value={value}
        onKeyPress={handleKeyPress}
        autoFocus={autoFocus}
        fullWidth={fullWidth}
        autoComplete={autoComplete}
        id={id}
        placeholder={placeholder}
        error={error}
        name={name}
        type={type}
        bgwhite={bgwhite}
        disabled={disabled}
        ref={ref}
        onBlur={onBlur}
        onFocus={onFocus}
        {...InputProps}
      />
      {!helperText && (
        <FormHelperText classes={{ root: sx.helperTextRoot }} error={error}>
          {isFormatHint ? 'Field will be formatted as entered' : ''}
        </FormHelperText>
      )}
      {helperText && (
        <FormHelperText error={error}
          sx={{
            margin: 0,
            position: 'static',
            bottom: 0,
          }}>
          <Typography variant="caption" color="danger" sx={{ fontSize: '10px' }}>
            {helperText}
          </Typography>
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default MaskField
